import * as Yup from 'yup';
import { isAddress, isWalletAddress } from '../../utilities/address';
import { is_contract_name_unique, is_contract_address_unique } from '../../services/account';
import debounce from 'lodash.debounce';

function contractValidation(formData) {
  const schema = Yup.object().shape({
    name: Yup.string()
      .required('Contract Name is required')
      .test('unique_name', 'Contract name must be unique', async (contractName) => {
        if (formData.type === 'Update' && formData.current_name === contractName) return true;
        if (contractName) {
          const response = await debouncedApiContractName(
            { ...formData, current_name: formData.current_name?.trim() },
            contractName.trim()
          );
          if (!response) return true;
          return response.data?.data?.available;
        }
      }),
      
    address: Yup.string()
      .required('Contract Address is required')
      .test('unique_address', 'The address must be unique', async (address) => {
        if (formData.type === 'Update' && formData.current_address === address) return true;
        if (address) {
          const response = await debouncedApiContractAddress(
            { ...formData, current_address: formData.current_address?.trim() },
            address.trim()
          );
          if (!response) return true;
          return response.data?.data?.available;
        }
      }).test('is_address', 'The address is not valid', async (address) => {
        return isWalletAddress(address);
      }),
    chain: Yup.array().required('Chain is required'),
    contract_type: Yup.array().required('Contract type is required'),
  });
  return schema;
}

const debouncedApiContractName = debounce(is_contract_name_unique, 500);

const debouncedApiContractAddress = debounce(is_contract_address_unique, 500);

export { contractValidation };
